module.exports = __webpack_public_path__ + "img/playVideo.27b60c5e.png";